import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'banners',
                label: 'Banners',
                routerLink: ['/extensions/banners'],
                icon: 'image',
            },
            'marketing'
        ),
    ],
})
export class BannerNavModule {}
